module.exports = __webpack_public_path__ + "img/refresh.62a8bb40.svg";